export const widgetSideToggle = (e) => {
	e.preventDefault();
	e.stopPropagation();

	const thisTarget = e.currentTarget;
	const a11yLabel = thisTarget.querySelector('.visually-hidden');
	const thisSection = thisTarget.closest('section');
	const thisContent = thisSection.querySelector('.abi-widget-inner');

	if( thisTarget.getAttribute('aria-expanded') === 'false'){

		thisSection.dataset.visible = 'show';
		thisTarget.setAttribute('aria-expanded', true);
		a11yLabel.textContent = 'コンテンツを閉じる';
		thisContent.setAttribute('aria-hidden', false);
		thisContent.dataset.display = '';

	} else {

		thisSection.dataset.visible = 'hide';
		thisTarget.setAttribute('aria-expanded', false);
		a11yLabel.textContent = 'コンテンツを開く';
		thisContent.setAttribute('aria-hidden', true);
		thisSection.addEventListener('transitionend', function () {
			thisContent.dataset.display = 'none';
		}, {
			once: true
		});

	}

}

window.widgetSideToggle = widgetSideToggle;